<template>
  <section class="full">
    <Scrollama
      :offset="0.5"
      :debug="false"
    >
      <div slot="graphic" class="graphic">
        <!-- Controls -->
        <div class="dimensions">
          <div class="title">
            Display
          </div>
          <a
            v-for="(dimension,index) in dimensions"
            @click="applyDimension(dimension)"
            :key="index"
            :class="{ selected: selectedDimension==dimension }"
          >{{ dimension }}</a>
        </div>
        <div class="scale">
          <div class="title">
            Zoom
          </div>
          <a
            v-for="(scale,index) in scales"
            @click="applyScale(scale)"
            :key="index"
            :class="{ selected: selectedScale==scale }"
          >{{ scale }}x</a>
        </div>
        <div v-if="!dataLoaded" class="preloader">
          <img class="wait" src="/assets/images/ajax-loader.gif" alt="... won't be long ...">
          <p>... won't be THAT long ...</p>
        </div>
        <!-- Visualization -->
        <div id="camera-viz" class="d3-viz camera-viz">
          <div id="tooltip" class="tooltip">
            <div class="pointer" id="pointer">
              <p class="text">
                <span id="dimension" />:
                <span id="dimensionValue" />
              </p>
              <p @click.stop="showImages($event)" class="view" id="view-btn">
                <span id="amount" /> photos
              </p>
            </div>
            <div @click.stop="removeToolTip" class="close icofont-close" />
          </div>
        </div>
      </div>

      <!-- Photo Gallery -->
      <div class="step photo-gallery" data-step="photo-gallery">
        <div v-if="imagesShown">
          <div @click="removeToolTip()" class="closeImages">
            <span class="icofont-close btn-close" />
            <span>
              <b>{{ getFirstUpper(cameraviz.selectedBrand) }}</b>
              : Top {{ imageGalleryMax }} photos with
              <em>{{ selectedDimension }}</em>&nbsp;
              <b>{{ selectedValue }}</b>
            </span>
          </div>

          <div class="row">
            <div v-for="(imageRow, i) in imageRows" :key="i" class="column">
              <div
                v-for="image in imageRow"
                :key="image.id"
                class="imgContainer"
                :style="'background-color:' + image.color"
              >
                <a :href="getCredits(image,'camera').url" target="_blank">
                  <img
                    src="/assets/images/transparent.png"
                    class="lzy_img"
                    :data-src="getImageURL(image.id)"
                    :alt="image.tag"
                    :style="'background-color:' + image.color"
                  >
                  <span class="credit">
                    Photo by {{ getCredits(image, "camera").username }} on
                    <a
                      :href="$root.unsplashURL + utmStr"
                      target="_blank"
                    >Unsplash</a>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Scrollama>
  </section>
</template>

<script>
import CameraViz from "../js/camera/d3-camera"
import CameraVue from "../views/Camera.vue"
import "intersection-observer"
import Scrollama from "vue-scrollama"
import { lazyLoadImages } from "../mixins/lazyLoad.js"
import { photogallery } from "../mixins/photo-gallery.js"
import _ from "lodash"

export default {
    name: "CameraViz",
    mixins: [lazyLoadImages, photogallery],
    components: {
        Scrollama
    },
    data() {
        return {
            cameraviz: null,
            dataLoaded: false,
            data: null,
            displayCredit: false,
            utmStr: "",
            scales: [1, 4, 16, 4096],
            selectedScale: 1,
            dimensions: ["Focal Length", "ISO", "Exposure Time", "Aperture"],
            selectedDimension: "Focal Length",
            selectedValue: null,
            imageArray: [],
            imageGalleryMax: 100,
            selectedTagName: "",
            imagesShown: false,
            currentStepProgress: null
        }
    },

    mounted() {
    // console.clear()
        console.log("camera created() - Let's go!")

        if (localStorage.d3_cameraSettings) {
            const locStorage = JSON.parse(localStorage.d3_cameraSettings)
            this.selectedScale = locStorage.settings.zoomScale
            this.selectedDimension = locStorage.settings.selectedDimensionText
        }

        // Create new Class of viz
        const cameraviz = new CameraViz("camera-viz")
        this.cameraviz = cameraviz

        this.data = cameraviz.loadData("unsplash-d3-all").then(json => {
            this.dataLoaded = true
            this.data = json
            cameraviz.init()
            cameraviz.drawBase()

            cameraviz.drawContent(json)
            this.applyScale(this.selectedScale)
        })

        window.addEventListener("resize", () => {
            this.resizeDebounced()
        })
    },
    methods: {
        resizeDebounced: _.debounce(function draw() {
            this.cameraviz.resize()
        }, 250),

        removeToolTip() {
            this.cameraviz.hideToolTip()
            this.hideImages()
        },
        redrawViz() {
            cameraviz.drawBase("camera-viz", this.data)
            cameraviz.drawContent(this.data)
        },

        getFirstUpper(str) {
            return _.upperFirst(str)
        },
        removeImage(photoData) {
            const imgEl = document.getElementById("app")
            imgEl.style.backgroundImage = ""

            this.removeToolTip()
            this.displayCredit = false
        },
        applyScale(value) {
            this.removeToolTip()

            this.selectedScale = value
            if (value === 1) {
                this.cameraviz.removeBrush()
            } else {
                this.cameraviz.drawBrush(value)
            }
        },
        applyDimension(value) {
            this.removeToolTip()

            this.selectedDimension = value
            this.cameraviz.changeDimensions(value)
        },
        showImages(event) {
            const index = event.target.dataset.index

            // find all images with this tag
            this.imageArray = this.data
                .filter(obj => {
                    let dimValue
                    let dimValueOrg
                    if (this.cameraviz.selectedDimension != "exposure_time") {
                        dimValue = Math.round(this.cameraviz.selectedValue)
                        dimValueOrg = Math.round(
                            obj.exif[this.cameraviz.selectedDimension]
                        )
                    } else {
                        dimValue = this.cameraviz.selectedValue.substring(
                            0,
                            this.cameraviz.selectedValue.length - 2
                        )
                        dimValueOrg = obj.exif[this.cameraviz.selectedDimension]
                    }

                    return (
                        dimValueOrg === dimValue &&
            _.split(_.lowerCase(obj.exif.make), " ")[0] ===
              this.cameraviz.selectedBrand
                    )
                })
                .slice(0, this.imageGalleryMax - 1)

            this.imagesShown = true
            this.selectedValue = this.cameraviz.selectedValue
            this.lazyLoadImages()

            const gallery = document.querySelector(".photo-gallery")
            gallery.classList.add("active")
        },
        hideImages() {
            this.imagesShown = false
            this.selectedTagName = ""

            const gallery = document.querySelector(".photo-gallery")
            gallery.classList.remove("active")
        },
        getImageURL(id) {
            const photoNode = this.data.find(obj => {
                return obj.id === id
            })

            // Target width : 800px
            const targetWidth = 800
            const targetheight = (targetWidth / photoNode.width) * photoNode.height
            const imageURL = `${photoNode.urls.raw}&w=${targetWidth}&h=${targetheight}&fit=crop&q=85&fm=jpg&crop=entropy&cs=srgb`

            return imageURL
        },
    }
}
</script>

<style src="vue-scrollama/dist/vue-scrollama.css"></style>

<style scoped lang="stylus">
@import './css/photogallery.styl';
@import './css/tooltip.styl';

.d3-viz >>> svg {
  & .tick-icon {
    font-family: 'IcoFont' !important;
  }

  & .brand {
    font-size: 18px;
  }

  & .model {
    font-size: 14px;
  }

  & .overlay, .handle {
    pointer-events: none; // prevent creation of new brushes and resizing
  }

  $ .dimmed {
    opacity: 0.1;
    stroke-width: 5;
    stroke: #000;
  }
}

.full {
  text-align: center;
  margin: 0 auto;

  & .graphic {
    padding-top: 20px;
  }

  & .d3-viz {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;

    & div {
      margin: 0 auto;
    }
  }

  & .scale, .dimensions {
    text-align: left;
    max-width: 800px;
    margin: 0 auto;
    font-size: 12px;

    & .title {
      width: 110px;
      // border: 1px solid red
      margin-right: 20px;
      padding-left: 20px;
      display: inline-block;

      @media (max-width: 600px) {
        display: block;
      }
    }

    & a {
      padding: 5px 10px;
      margin: 0 5px;
      border: 1px solid darkgrey;
      cursor: pointer;

      @media (max-width: 600px) {
        &:first-of-type {
          margin-left: 20px;
        }
      }

      &.selected {
        color: white;
        background-color: darkgrey;
      }
    }
  }

  & .preloader {
    margin: 100px auto;
    text-align: center;
  }
}
</style> 


